require.register("modules/m0x/a04/page-45-il/page-45-il", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_44_states = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_44_states;

  
});

